import {useEffect, useState} from 'react';
import {ArrowRight, BookOpen, CheckCircle, Play} from 'lucide-react';
import {Link, useSearchParams} from "react-router-dom";
import {URLS} from "@/lib/urls";
import {useApiLmLevelList} from "@/api/lms";
import RenderIf from "@/components/render-if";
import {Skeleton} from "antd";
import {Coding} from "@/lib/helper/coding";

function LmsLevelListPage(props) {

    const [currentGroup, setCurrentGroup] = useState({})
    const [searchParams, setSearchParams] = useSearchParams();

    let groupId = searchParams.get("id");

    groupId = Coding.decode(groupId);


    const {data: levelList, isPending, isSuccess} = useApiLmLevelList(groupId)

    useEffect(() => {
        if (levelList?.data?.data?.length > 0) {
            setCurrentGroup(levelList.data?.data[0]?.group)
        }
    }, [groupId, levelList])

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('fa-IR');
    };


    return (
        <div className="h-full " dir="rtl">
            <>
                {/* Header Section */}
                <div className="  border-b border-gray-200/50 top-0 z-50">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                        {/* Back Button */}
                        <Link to={URLS.lms.groups}>
                            <button

                                className="flex items-center text-blue-600 hover:text-blue-700 mb-6 transition-colors duration-200"
                            >
                                <ArrowRight className="w-5 h-5 ml-2"/>
                                <span className="font-medium">بازگشت به گروه‌ها</span>
                            </button>
                        </Link>

                        <RenderIf condition={isPending}>
                            <Skeleton loading={isPending} className="w-full h-full"/>
                        </RenderIf>

                        {/* Group Info */}
                        {currentGroup.id && (
                            <div className="flex items-center mb-6">
                                <div className="w-16 h-16 rounded-2xl overflow-hidden ml-4 shadow-lg">
                                    <img
                                        src={currentGroup.file}
                                        alt={currentGroup.title}
                                        className="w-full h-full object-cover"

                                    />
                                </div>
                                <div>
                                    <h1 className="text-3xl font-bold  mb-2">
                                        {currentGroup.title}
                                    </h1>
                                    <p className="">
                                        مراحل آموزشی این گروه را مشاهده و شروع کنید
                                    </p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                {/* Stages List */}
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                    <div className="space-y-6">
                        {levelList?.data?.data?.map((stage, index) => (

                            <div
                                key={'one_level_' + index + '_' + stage.id}
                                className="group rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer
                                overflow-hidden border border-gray-100 dark:border-gray-600"

                                style={{
                                    animationDelay: `${index * 100}ms`,
                                    animation: 'fadeInUp 0.6s ease-out forwards'
                                }}
                            >
                                <Link

                                    to={
                                        stage.type === 'redirect' ? stage.redirecturl :
                                            URLS.lms.levelView + '/' + stage.type + '?id=' + Coding.encode(stage.id)}>
                                    <div className="flex items-center p-6">
                                        {/* Stage Image */}
                                        <div
                                            className="relative w-24 h-24 rounded-2xl overflow-hidden ml-6 shadow-md group-hover:shadow-lg transition-shadow duration-300">
                                            <img

                                                src={stage.file2}
                                                alt={stage.title}
                                                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"

                                            />
                                            <div
                                                className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
                                        </div>

                                        {/* Stage Content */}
                                        <div className="flex-1">
                                            <div className="flex items-start justify-between">
                                                <div>
                                                    <h3 className="text-xl font-bold  mb-2 group-hover:text-blue-600 transition-colors duration-200">
                                                        {stage.title}
                                                    </h3>
                                                    <div className="flex items-center  text-sm mb-3">
                                                        {/*<Calendar className="w-4 h-4 ml-1"/>*/}
                                                        {/*<span>{formatDate(stage.datecreated)}</span>*/}
                                                    </div>
                                                    <div className="flex items-center">
                                                        <div
                                                            className="px-3 py-1 bg-green-100 text-green-700 text-sm rounded-full font-medium ml-3">
                                                            <div className="flex items-center">
                                                                <CheckCircle className="w-3 h-3 ml-1"/>
                                                                <span>فعال</span>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                {/* Action Button */}
                                                <div className="flex items-center">
                                                    <div
                                                        className="w-12 h-12 bg-gradient-to-r from-blue-500 to-indigo-600 rounded-2xl flex items-center justify-center group-hover:from-blue-600 group-hover:to-indigo-700 transition-all duration-200 shadow-lg group-hover:shadow-xl">
                                                        <Play
                                                            className="w-6 h-6 text-white group-hover:scale-110 transition-transform duration-200"/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <RenderIf condition={false}>
                                        {/* Progress Bar */}
                                        <div className="px-6 pb-6">
                                            <div className="w-full bg-gray-200 rounded-full h-2">
                                                <div
                                                    className="bg-gradient-to-r from-blue-500 to-indigo-600 h-2 rounded-full transition-all duration-500"
                                                    style={{width: `${Math.random() * 100}%`}}
                                                ></div>
                                            </div>
                                        </div>
                                    </RenderIf>


                                    {/* Hover Overlay */}
                                    <div
                                        className="absolute inset-0 bg-gradient-to-r from-blue-600/5 to-indigo-600/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
                                </Link>
                            </div>
                        ))}
                    </div>

                    {/* Empty State */}
                    {levelList?.data?.data?.length === 0 && (
                        <div className="text-center py-16">
                            <div
                                className="w-24 h-24 mx-auto mb-6  rounded-full flex items-center justify-center">
                                <BookOpen className="w-12 h-12 "/>
                            </div>
                            <h3 className="text-xl font-semibold  mb-2">مرحله‌ای یافت نشد</h3>
                            <p className="">هنوز مرحله‌ای برای این گروه تعریف نشده است</p>
                        </div>
                    )}
                </div>
            </>

        </div>
    );
}

export default LmsLevelListPage;